/* unplugin-vue-components disabled */import script from "./FilePreviewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreviewDialog.vue?vue&type=script&setup=true&lang=js"

import "./FilePreviewDialog.vue?vue&type=style&index=0&id=7ff4839c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff4839c"]])

export default __exports__